const toast = {
  message: {
    success: '¡Éxito!',
    error: 'Algo salió mal',
  },
};

export default toast;
